import type { TrackImportResult } from '@internal/backstage-plugin-pulse-common';
import { ImportResultBanner } from '../import-result-banner';

type TrackImportResultBannerProps = {
  result: TrackImportResult;
  onDismiss: () => void;
};

export const TrackImportResultBanner = ({
  result,
  onDismiss,
}: TrackImportResultBannerProps) => (
  <ImportResultBanner result={result} itemLabel="Track" onDismiss={onDismiss} />
);
